import { useState, useRef, useEffect } from 'react';
import { createSelector } from 'reselect';
import { push, replace } from 'react-router-redux';

import { useRedux } from './redux';

export const useBoolean = (options = {}) => {
	const { onTrue = () => {}, onFalse = () => {}, defaultBoolean = false } = options;

	const [boolean, setState] = useState(defaultBoolean);

	const toggle = () => {
		if (boolean) {
			onFalse();
		} else {
			onTrue();
		}
		setState(!boolean);
	};

	const setFalse = () => {
		setState(false);
		onFalse();
	};

	const setTrue = () => {
		setState(true);
		onTrue();
	};

	return [boolean, { toggle, setFalse, setTrue }];
};

const selectReactRouter = createSelector(
	state => state.routing.locationBeforeTransitions,
	location => location,
);

export const useReactRouter = () => useRedux(selectReactRouter, { push, replace });

export const useTimeout = (execute, time, triggerEffect = []) => {
	const timer = useRef(null);

	useEffect(() => {
		if (timer.current === null && time > 0) {
			timer.current = setTimeout(execute, time);
		}

		return () => {
			if (timer.current) {
				clearTimeout(timer.current);
				timer.current = null;
			}
		};
	}, [time, execute, ...triggerEffect]);
};
